<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Homepage About-Us</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Content
        </span>
      </base-button>
    </div>
    <aboutUsTable />
  </b-card>
</template>

<script>
import aboutUsTable from "./components/aboutUsTable.vue";
export default {
  components: {
    aboutUsTable,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "add-homepage-aboutus" });
    },
  },
};
</script>
<style></style>
